import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

export const initApartmentCompilations = () => {
	const apartmentCompilations = document.querySelectorAll( 'section.apartment-compilations' );

	if ( !apartmentCompilations.length )
	{
		return;
	}

	Array.from( apartmentCompilations ).forEach( ( it ) => {
		const apartmentCompilationsSliders = it.querySelectorAll( 'div.swiper-compilations' );

		Array.from( apartmentCompilationsSliders ).forEach( ( slider ) => {
			const btnNext = slider.querySelector( '.swiper-button-next' );
			const btnPrev = slider.querySelector( '.swiper-button-prev' );

			const swiper = new Swiper( slider, {
				slidesPerView: 'auto',
				freeMode: true,
				modules: [Navigation],
				navigation: {
					nextEl: btnNext,
					prevEl: btnPrev,
					disabledClass: 'swiper-button-disabled',
				},
			} );
		} );

		it.addEventListener( 'change', ( evt ) => {
			it.querySelector( 'label.current' ).classList.remove( 'current' );
			it.querySelector( `label[for="${evt.target.id}"]` ).classList.add( 'current' );
		} );
	} );
};
